import React from "react";
import C from "../constants/colors";

const HeroHeader = ({ unit, project, block, sold }) => (
  <div className="ud-hero">
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "0.375rem" }}>
        <h1 style={{ margin: 0, fontSize: "2.25rem", fontWeight: 800, color: C.primary, letterSpacing: "-0.03em" }}>
          {unit?.nr}
        </h1>
        {sold ? (
          <span className="ud-status-badge" style={{ background: "#ede9fe", color: "#6d28d9" }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#6d28d9", flexShrink: 0 }} />
            Sold
          </span>
        ) : (
          <span className="ud-status-badge" style={{ background: "#ecfdf5", color: "#059669" }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#059669", flexShrink: 0 }} />
            Available
          </span>
        )}
      </div>
      <p style={{ margin: 0, fontSize: "0.8125rem", fontWeight: 500, color: C.muted }}>
        {[project?.name, block?.name, unit?.floor != null && `Level ${unit.floor}`, unit?.apt_type]
          .filter(Boolean)
          .join(" · ")}
      </p>
    </div>

    <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
      <button
        type="button"
        style={{ padding: "0.5rem 1.25rem", background: "#fff", border: `1.5px solid ${C.border}`, color: C.primary, borderRadius: 8, fontWeight: 700, fontSize: "0.8125rem", cursor: "pointer", display: "flex", alignItems: "center", gap: "0.4rem" }}
      >
        <i className="ri-edit-line" /> Edit Unit
      </button>
      <button
        type="button"
        style={{ padding: "0.5rem 1.25rem", background: C.primary, border: "none", color: "#fff", borderRadius: 8, fontWeight: 700, fontSize: "0.8125rem", cursor: "pointer", display: "flex", alignItems: "center", gap: "0.4rem" }}
      >
        <i className="ri-download-2-line" /> Download Ledger
      </button>
    </div>
  </div>
);

export default HeroHeader;
